<template>
  <!-- 考试页面 -->

  <popup ref="popup" :loading="popupLoading" @beforeClose="close">
    <div slot="body" style="padding-top: 20px">
      <div class="operator">
        <el-row>
          <el-col :span="5">
          </el-col>
          <el-col :span="3"> 当前得分：{{ score }} / {{ maxScore }} </el-col>
          <el-col :span="11"> </el-col>
        </el-row>
      </div>
      <el-form class="dataForm" ref="form" :disabled="disabled" :inline="true">
        <el-row>
          <el-col :span="24">
            <!-- 简答、论述、编程题 -->
            <el-card v-if="stuQueArray[0]" v-for="(qu, idx1) in stuQueArray" :key="idx1 + '5'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left">
                  <span style="color: #cc0000">模拟面试</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b><br>
                <textarea cols="100" rows="3" disabled v-model="qu.question.title"></textarea><br>
           
              <b style="color: #00cc00">[{{ qscore[idx1] }}分]</b>
              <b>判定得分：{{ (qscore[idx1] * stararr[idx1]/5).toFixed(0)}} <el-rate v-model="stararr[idx1]" @change="changeScore($event, idx1)"></el-rate></b>

              <div v-for="(ch, idx2) in qu.question.choiceList" :key="idx2 + '11'">
                <el-button :class="ch.o == qu.flag ? 'bg-purple' : ''" plain size="mini">{{ ch.o }}.{{ ch.n }}</el-button>
              </div>

              <div style="width: 50%">
                <span class="title-color-red">标准答案：
                  <span style="color: #777; font-size: 13px" v-html="qu.rigthAnsr"></span></span>
                <br />
                <span  v-if="qu.analysis">
                <span   class="title-style-bold margin-top-20">题目解析:</span>
                <span style="color: #777; font-size: 13px" v-html="qu.analysis"></span></span>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-form>

      <!-- 解析弹出面板 -->
      <el-dialog title="查看题目解析" :visible.sync="dialogFormVisible" :append-to-body="true" ref="analysisForm">
        <el-form :model="currentAnalysis">
          <el-form-item  >
            <el-input type="textarea" readonly v-model="currentAnalysis.analysis" rows="12"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('cancel')">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-row>
        <el-col :span="21">
          <el-button v-if="!disabled" type="danger" :loading="confirmLoading" @click="close()">关 闭</el-button>
          <el-button type="warning"   v-show="!this.stuAnwser.isjudged == 1"
              @click="submitPigai()">提交成绩</el-button>
        </el-col>
        <el-col :span="3"> </el-col>
      </el-row>
    </div>
  </popup>
</template>
<script>
import popup from "@/components/popup/drawerPopupSta.vue";
import FillInTheBlanks from "@/components/exams/FillInTheBlanks.vue";
import api from "@/api/exams/exams/exams.js";
import ansrApi from "@/api/exams/exams/answers.js";

export default {
  components: {
    popup,
    FillInTheBlanks,
  },
  data() {
    return {
      countDown: "",
      popupLoading: false,
      disabled: false,
      confirmLoading: false,

      exam: {}, //exam
      kid: "", //考试id

      studentNeedList: "", //应考学生列表

      student: {}, //当前批改的学生
      stuIndex: 0, //当前批改的学生 在数组中的位置
      exp: {}, //试卷
      expId: null, //试卷ID
      needExmCnt: 0, //该考试的人数
      corectCnt: 0, //已批改人数
      score: 0, //当前得分

      maxScore: 0, //试卷总分
      typeTxArr: [],
      stuAnwser: { isjudged: 0 }, //学生答案
      toInterviewerId: "", //被面试的考生的id
      answerId: '',    //考卷(answer记录)的id
      stararr: [],    //打分控件

      qscore: 0, //每题得分

      //改分前的得分
      lastRscore: 0,

      //题类型位置
      choice_question: { show: false },
      //总题数组
      questionArray: [],
      //当前学生的题目
      stuQueArray: [],

      dialogFormVisible: false, // 题目解析弹出是否可见
      currentAnalysis: {}, // 当前题目的解析
    };
  },
  methods: {
    //给每个考生随机生成题目
    genRdmArr() {
      //试图取得学生的答案 如果该学生已完成面试
      api.getOneAnswers({ kid: this.kid, sid: this.toInterviewerId }, (res) => {
        if (res.data.isjudged == 1) {
          //已考
          //record
          this.stuAnwser = res.data;
          this.score = this.stuAnwser.score;
          //试题id
          this.stuQueArray = JSON.parse(this.stuAnwser.answer);

          //手动强制刷新
          this.$forceUpdate();
        } else {
          this.answerId = res.data.id;
          this.stuQueArray = this.questionArray
        }

      });
    },
    //提交考生成绩
    submitPigai() {
      //询问是否完成批改？完成批改  ： 暂存成绩
      this.$confirm("是否提交当前成绩？", "试卷批改提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
      }).then(() => {
        //第一个 卷封装答案
        let stuQueArray = []
        this.stuQueArray.forEach(v => {
            stuQueArray.push({ id:v.id,  i:v.i,  qscore:v.qscore, rscore:v.rscore?v.rscore:0 })
        });

        let record = {
          isjudged: 1,
          id: this.answerId,
          score: this.score,
          expid: this.expId,
          type: 4,
          answer: stuQueArray,
        };
      //  console.log("准备提交的内容", record);


        //提交判卷
        ansrApi.updateInterViewAnswer(
          record,
          (res) => {
            this.$utils.msg.success(res.msg);
            this.corectCnt += 1;
            this.stuAnwser.isjudged = 1;
            this.close()
          },
          (err) => {
            this.$utils.msg.warning(err.msg);
          }
        );
      });
    },


    //初始化学生答案对象
    initPaper() {
      //试卷中的试题ID---->试题
      console.log("正在初始化试卷",this.student);
      api.getexpContent1({ expid: this.expId , stuid: this.toInterviewerId, kid:this.kid}, (response) => {
        //获取到的是试卷数据的json数据，jion数据在最外层添加了content属性,该属性为 exampaper里面content字段中处理过的contents，里面是qid

        //将试卷数据绑定在页面上
        this.exp = JSON.parse(response.data);
        console.log("this.exp", this.exp);
        //this.maxScore = this.exp.score; //满分
        this.maxScore = 100; //满分

        this.questionArray = this.exp.contents[0].qid
        this.qscore = this.exp.contents[0].qscore
       

        //题型
        //let content = JSON.parse(this.exp.content);
       // console.log("题型", content);

        // this.typeTxArr = content.types; //题型数组
        // this.typeTxArr.forEach((v, i) => {
        //   //初始化答案
        //   let qscore = content.contents[i].qscore;
        //   //回显答案
        //   this.exp.contents[i].qid.forEach((v1, i1) => {
        //     v1.qscore = qscore[i1];
        //   });
        //   //所有题型都放入简答
        //   this.questionArray = [
        //     ...this.questionArray,
        //     ...this.exp.contents[i].qid,
        //   ];
        //   console.log("this.questionArray", this.questionArray);
        // });

        this.genRdmArr();
      });
    },
    //打开弹框
    //加个参数，加上被面试人的id传进来
    open(kid, title, disabled, sid, toInterviewerId) {
      this.stararr = [];
      this.sid = sid

      this.toInterviewerId = toInterviewerId;
      this.kid = kid;
      // 加载试卷+考试             //返回的数据有  exam 已批改的人数 全部人数 该考试的学生列表
      api.findPaperByKid({ kid: this.kid }, (res) => {
        console.log("查询考试试卷", res);
        //将考试数据绑定在页面
        this.exam = res.data.exm;

        //100分制计算每题得分  quenum只有面试才有
        this.qscore = Math.floor(100 / this.exam.quenum);

        for (let i = 0; i < this.exam.quenum; i++) {
          this.stararr.push(0)
        }
        console.log("stararr", this.stararr);

        //将考试卷ID绑定在页面
        this.expId = this.exam.expid;

        this.studentNeedList = this.exam.sid;
        this.needExmCnt = JSON.parse(this.studentNeedList).length; ////学生数量

        console.log("准备初始化试卷");

        //初始化第一个学生答案
        this.initPaper();

        this.$refs.popup.open(title, "100%");
        //2. 发起请求 根据  考试ID +学生ID 查回一个试卷+答案

        this.disabled = disabled;
      });
    },
    checkInScore($event) {
      if ($event.target.value) {
        this.score -= $event.target.value;
        if ($event.target.value > 10 || $event.target.value < 0) {
          this.score += $event.target.value;
        }
        $event.target.value = 0;
        this.lastRscore = $event.target.value;
      }
    },
    close() {


      // this.$confirm("警告： 当前成绩没有保存将被放弃？", "关闭考试提示", {
      //   distinguishCancelAndClose: true,
      //   confirmButtonText: "提交",
      //   cancelButtonText: "取消",
      // }).then(() => {

      this.disabled = false;
      this.$refs.popup.closeCallback();
      //退出初始化参数
      this.score = 0;
      this.countDown = "";
      this.popupLoading = false;
      this.disabled = false;
      this.confirmLoading = false;
      this.exam = {};
      this.choice_question = { show: false };

      this.currentAnalysis = {};
      this.stuIndex = 0;
      this.examPapers = {}; //伪数组  :把对象当数组用，实现'键值对'Map

      this.student = {};

      this.score = 0  //当前得分
      //改分前的得分
      this.lastRscore = 0;

      //备选题
      this.questionArray = [];
      this.$parent.list();
     // })

    },

    // 初始化题目解析表单
    resetForm(status) {
      this.dialogFormVisible = false;
    },
    // 获取当前题目的解析内容
    getCurrentAnalysis(data) {
      this.currentAnalysis = data;
      this.dialogFormVisible = true;
    },
    //打分时触发
    changeScore(e, idx) {
      this.stuQueArray[idx].rscore = this.qscore[idx] / 5 * e;
      this.score = 0;
      this.stuQueArray.forEach((v, i) => {
        //console.log(this.stuQueArray[i].rscore);
        this.score += typeof this.stuQueArray[i].rscore !== 'undefined' ? this.stuQueArray[i].rscore : 0;
      })
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.text {
  display: inline-block;
  padding: 0 20px;
}

.operator {
  position: absolute;
  top: 50px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 999;
}

.title-style-bold {
  color: #000;
  font-weight: bold;
}

.title-color-red {
  color: red;
}

.margin-top-20 {
  margin-top: 20px;
  display: block;
}

.update-note {
  display: block;
  margin-top: 20px;
}
</style>